export enum RoleEnum {
    'tourist' = 1,
    'supervisor',
    'admin',
}
